export const settings = { 
    version:'2.0.0',
    isDark: false
};
export default { settings };
